import { Grid, Skeleton } from '@mui/material'
import { EnrollmentDetails } from 'Components/Enrollment/EnrollmentDetails'
import { ActionTracker } from 'Components/Enrollment/ActionTracker'
import { ChildInfoCard } from 'Components/ChildDetails/ChildInfoCard'
import CareNetworkDetails from 'Components/CareNetwork/CareNetworkDetails'
import { ProgramVerification } from 'Components/Program/ProgramVerification'
import { useEffect, useState } from 'react'
import { useParams, generatePath, useNavigate } from 'react-router'
import { useRefresh } from 'ContextProviders/RefreshProvider'
import { sendGet } from 'hooks/use-fetch'
import { CareManagementSummary } from 'Components/CareManagement/CareManagementSummary'
import { LocationCardList } from 'Components/Cards/MultiCardList/LocationCardList'
import { EnrollmentActionBar } from 'Components/Enrollment/EnrollmentActionBar'
import { type BasicEnrollmentData } from 'core/types'
import * as AppRoutes from 'Pages/Routes'
import { NewServiceSelection } from 'Components/Services/NewServiceSelection'
import { useSearchParams } from 'react-router-dom'
import { usePermissions } from 'hooks/use-permissions'

export interface enrollmentData {
  id: number
  childID: number
  childName: string
  programVerificationID: number | null
  serviceName: string
  isdspServiceID: number
  serviceID: number

}
export function EnrollmentDetailsPage (): JSX.Element {
  const { id } = useParams()
  const [params] = useSearchParams()
  const refreshTime = useRefresh()
  const [enrollmentData, setEnrollmentData] = useState<BasicEnrollmentData | null>(null)
  const nav = useNavigate()
  const perms = usePermissions()
  function openChildEdit (): void {
    const editChild = `${generatePath(AppRoutes.CARENETWORK_MANAGEMENT_EDIT, { id: enrollmentData?.childID.toString() ?? '0' })}?enrollmentID=${enrollmentData?.id.toString() ?? '0'}`
    nav(editChild, { state: { redirectText: 'Enrollment Details' } })
  }

  useEffect(() => {
    const loadData = async (): Promise<void> => {
      const { response } = await sendGet(`/NewEnrollment/GetBasicDetails?id=${id ?? 0}`, {})
      setEnrollmentData(response)
    }
    if (id != null) { void loadData() }
  }, [id, refreshTime])
  if (enrollmentData == null) { return <Skeleton /> }
  return <Grid container columnSpacing={2} rowSpacing={2} sx={{ m: 'auto', maxWidth: '1000px' }}>
    <Grid item xs={12} sm={6} lg={4}>
      <Grid container spacing={2}>
        <Grid item width={'100%'}>
          <EnrollmentDetails enrollmentID={enrollmentData.id} canReview={false} />
        </Grid>
        {perms.Enrollment_Edit &&
          <Grid item width={'100%'} sx={{ display: 'flex', justifyContent: 'center' }}>
            <NewServiceSelection isdID={enrollmentData.isdID} childID={enrollmentData.childID} />
          </Grid>
        }
        <Grid item width={'100%'}>
          <ActionTracker enrollmentId={enrollmentData.id} />
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={12} sm={6} lg={4}>
      <Grid container spacing={2}>
        <Grid item width={'100%'}>
          <ChildInfoCard id={enrollmentData.childID} onEdit={(enrollmentData.readOnlyAccess ? undefined : openChildEdit)} pendingDuplicateID={enrollmentData.childPendingDuplicateID } />
        </Grid>
        <Grid item width={'100%'}>
          <LocationCardList childID={enrollmentData.childID} pendingDuplicateID={enrollmentData.childPendingDuplicateID} readOnly={enrollmentData.readOnlyAccess} />
        </Grid>
        <Grid item width={'100%'}>
          <CareNetworkDetails redirectText='Enrollment Details' readOnly={enrollmentData.readOnlyAccess || !(perms.Enrollment_Edit || perms.CareNetwork_Enrollment_Edit)} childId={enrollmentData.childID} />
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={12} sm={6} lg={4}>
      <Grid container spacing={2}>
        <Grid item width={'100%'}>
          <ProgramVerification showIncome verificationId={enrollmentData.programVerificationID?.toString() ?? ''} redirectText='Enrollment Details' readOnly={enrollmentData.readOnlyAccess || !(perms.Enrollment_Edit || perms.CareNetwork_Enrollment_Edit)}/>
        </Grid>
        <Grid item width={'100%'}>
          <CareManagementSummary childID={enrollmentData.childID} childName={'test'} readOnly={enrollmentData.readOnlyAccess} />
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={12}>
      <EnrollmentActionBar enrollmentId={enrollmentData.id} childId={params.get('childID') == null ? undefined : Number(params.get('childID'))} serviceId={enrollmentData.serviceID} />
    </Grid>
  </Grid>
}
